export default "__VITE_ASSET__CZcRSHmx__"